import $ from "jquery";
import moment from "moment";

if (typeof window !== "undefined") {
  window.jQuery = $;
  window.$ = $;
  window.moment = moment;
}
